import { render } from "./Create.vue?vue&type=template&id=47201e8c"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Sector/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47201e8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47201e8c', __exports__)) {
    console.log('reload')
    api.reload('47201e8c', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=47201e8c", () => {
    console.log('re-render')
    api.rerender('47201e8c', render)
  })

}


export default __exports__